import Metadata from '../../../requests/apa/Metadata';
import Translator from '../../../requests/apa/Translator';
import { linkDeviceOTP, linkSessionAddPaymentMethod } from '../../../requests/loader';
import { AAF_MODAL_ERROR, AAF_MODAL_QR_LOGIN, AAF_MODAL_TELMEX_ADD_NEW_PAYMENTMETHOD, AAF_MODAL_TELMEX_EDIT_PAYMENTMETHOD } from '../../../actions/modal';
import { showModal } from '../../../actions/modal';
import { TELMEX_REGISTER, LOGIN, REGISTER, REGISTRATE, LANDING, INICIASESION, TELMEX } from '../../../components/Modal/LoginQR/const';
import Utils from "../../../utils/Utils";
import store from '../../../store';
import {GA4} from '../../../utils/trackers/GA4';

export const handleClickIniciaSesion = async (props) => {
	sendMetrics(INICIASESION, LANDING, props);
	const keyAction = Translator.get('key_link_flow_login');
	if (keyAction === '' || keyAction === null || keyAction === undefined || keyAction === 'key_link_flow_login') {
		showModalError();
	} else {
		try {
			const response = await linkDeviceOTP({ keyAction });
			const dataLinkDeviceOTP = response && response.data;
			dataLinkDeviceOTP && showModalLoginQR({dataLinkDeviceOTP, typeModal: LOGIN});
		} catch (error) {
			showModalError();
		}
	}
};

export const handleClickRegistraCorreo = async (props) => {
	sendMetrics(REGISTRATE, LANDING, props);
	const keyAction = Translator.get('key_link_flow_registro');
	if (keyAction === '' || keyAction === null || keyAction === undefined || keyAction === 'key_link_flow_registro') {
		showModalError();
	} else {
		try {
			const response = await linkDeviceOTP({ keyAction });
			const dataLinkDeviceOTP = response && response.data;
			dataLinkDeviceOTP && showModalLoginQR({dataLinkDeviceOTP, typeModal: REGISTER});
		} catch (error) {
			showModalError();
		}
	}
};

export const handleClickRegistroTelmex = async (props) => {
	sendMetrics(TELMEX, LANDING, props);
	const keyAction = Translator.get('key_link_flow_registro_telmex');
	if (keyAction === '' || keyAction === null || keyAction === undefined || keyAction === 'key_link_flow_registro_telmex') {
		showModalError();
	} else {
		try {
			const response = await linkDeviceOTP({ keyAction });
			const dataLinkDeviceOTP = response && response.data;
			dataLinkDeviceOTP && showModalLoginQR({dataLinkDeviceOTP, typeModal: TELMEX_REGISTER});
		} catch (error) {
			showModalError();
		}
	}
};

export const handleClickAddPaymentMethod = async () => {
	const redirectUrl = Translator.get('MDP_MetodosDePago_ModalQRAgregarMDP_Enlace_Texto_AgregarMDP');
	if (redirectUrl === '' || redirectUrl === null || redirectUrl === undefined || redirectUrl === 'MDP_MetodosDePago_ModalQRAgregarMDP_Enlace_Texto_AgregarMDP') {
		showModalError();
	} else {
		try {
			const response = await linkSessionAddPaymentMethod(redirectUrl);
			const dataLinkSeesion = response && response.data;
			dataLinkSeesion && showModalAddNewPaymentMethod({dataLinkSeesion});
		} catch (error) {
			showModalError();
		}
	}
};


export const handleClickEditPaymentMethod = async () => {
	const redirectUrl = Translator.get('MDP_MetodosDePago_ModalQREditarMDP_Enlace_Texto_EditarMDP');
	if (redirectUrl === '' || redirectUrl === null || redirectUrl === undefined || redirectUrl === 'MDP_MetodosDePago_ModalQREditarMDP_Enlace_Texto_EditarMDP') {
		showModalError();
	} else {
		try {
			const response = await linkSessionAddPaymentMethod(redirectUrl);
			const dataLinkSeesion = response && response.data;
			dataLinkSeesion && showModalEditPaymentMethod({dataLinkSeesion});
		} catch (error) {
			showModalError();
		}
	}
};

const sendMetrics = (interaction_type, moduleName, props) => {
	const gA4 = new GA4();
	const event = LANDING;
	const content_section = LANDING;
	const dataMetrics = Utils.getDataOnboardingIpTelmex(props.history, interaction_type, moduleName, event, content_section );
	gA4.sendMetricsOnboardingIPTelmex(dataMetrics);
}

const showModalError = () => {
	const modal = {
		modalType: AAF_MODAL_ERROR,
		modalProps: {}
	}
	store.dispatch(showModal(modal));
}

const showModalLoginQR = (response) => {
	const modal = {
		modalType: AAF_MODAL_QR_LOGIN,
		modalProps: {
			response: response,
		}
	}
	store.dispatch(showModal(modal));
}

const showModalAddNewPaymentMethod = (response) => {
	const modal = {
		modalType: AAF_MODAL_TELMEX_ADD_NEW_PAYMENTMETHOD,
		modalProps: {
			response: response,
		}
	}
	store.dispatch(showModal(modal));
}

const showModalEditPaymentMethod = (response) => {
	const modal = {
		modalType: AAF_MODAL_TELMEX_EDIT_PAYMENTMETHOD,
		modalProps: {
			response: response,
		}
	}
	store.dispatch(showModal(modal));
}





// WEBPACK FOOTER //
// ./src/authentication/components/LandingTelmex/utilsLandingTelmex.js